export const COORDINADOR_LIMPIEZA = "Andrea";

export const DEPARTAMENTOS_SIN_LIMPIEZA = ["boedo"];

export const DIAS_MAXIMOS_VERIFICACION = 7;

// Fechas sin personal habitual de limpieza. Formato: YYYY-MM-DD.
// Ejemplo: ["2026-05-25"]
export const FERIADOS_SIN_PERSONAL: string[] = [];

export type MotivoDiaSinPersonal = "domingo" | "feriado" | null;

export const RESPONSABLES_LIMPIEZA: Array<{
  nombre: string;
  departamentos: string[];
}> = [
  { nombre: "Andrea", departamentos: ["07", "08", "09", "10", "11", "12A"] },
  { nombre: "Mariela", departamentos: ["03", "05", "06", "18", "19"] },
  { nombre: "Gaby", departamentos: ["01", "02", "04", "12B", "14", "15", "16", "17"] },
  { nombre: "Mamá", departamentos: ["20", "21", "22", "23", "24"] },
  { nombre: "Altos", departamentos: ["25", "26", "27"] },
];

export const MOTIVOS_ATENCION = {
  salidaEntrada: "Salida + entrada",
  lateCheckout: "Salida tarde",
  pactada: "Pactada",
  domingo: "Domingo",
  sinPersonal: "Sin personal",
} as const;
